export { TabItems } from './TabItems';
export { TabItemsProps } from './TabItems.types';
